import { ForcedRankingsService } from 'src/services/ForcedRankingsService';

export const mutateForcedRankingStrategy = async (
    {
        accessToken,
        strategyName,
        data,
        signal,
    }: {
        accessToken: string | false;
        strategyName: string;
        data: Models.IngestConfigApi.ForcedRankings.ForcedRankingStrategy;
        signal?: AbortSignal;
    },
): Promise<Models.IngestConfigApi.ForcedRankings.ForcedRankingStrategy> => ForcedRankingsService
    .updateForcedRankingStrategy(
        accessToken,
        strategyName,
        data,
        signal,
    );
